import moment from 'moment';

const parseDate = (value, dateFormat) => {
	const isoDate = moment(value, moment.ISO_8601, true);
	return isoDate.isValid() ? isoDate : moment(value, dateFormat);
};

/**
 * The prop <dateFormat> is only required when <orderType> is "date"
 * The prop <objectKey> is only required when <orderType> is "object"
 * */
export default function orderBy(data, orderType, props) {
	const { dateFormat, objectKey, reverse } = props;

	switch (orderType) {
		case 'text':
			data.sort();
			break;
		case 'numeric':
			data.sort((a, b) => {
				return a - b;
			});
			break;
		case 'date':
			data.sort((a, b) => {
				return parseDate(a, dateFormat) - parseDate(b, dateFormat);
			});
			break;
		case 'objectDate':
			data.sort(function (a, b) {
				if (reverse) {
					return (
						parseDate(b[objectKey], dateFormat) -
						parseDate(a[objectKey], dateFormat)
					);
				}
				return (
					parseDate(a[objectKey], dateFormat) -
					parseDate(b[objectKey], dateFormat)
				);
			});
			break;
		case 'object':
			data.sort(function (a, b) {
				if (a[objectKey] > b[objectKey]) return reverse ? -1 : 1;
				if (a[objectKey] < b[objectKey]) return reverse ? 1 : -1;
				return 0;
			});
			break;
	}
}
